import { Injectable } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { CreateBoudDialogComponent } from '../dialogs/boud/create-boud/create-boud.dialog';
import { BoudActionTypes } from '../store/actions/boud-actions';
import { UdeuBoud, UdeuCreateBoud } from '../model/classes/udeu-boud';
import { AlfrescoApiService } from '@alfresco/adf-core';
import { NodePaging } from '@alfresco/js-api';
import { SYS_NODE_UUID_PROP } from '../model/contants/deusto';

@Injectable({
  providedIn: 'root'
})
export class BoudService {
  constructor(public dialog: MatDialog, private alfrescoApiService: AlfrescoApiService) { }

  openBoudDialogComponent(UUID?: string, boudActionType: BoudActionTypes = BoudActionTypes.CreateBoud, selectedIndex?: number): void {
    this.dialog.open(CreateBoudDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%',
        data:  { UUID, boudActionType, selectedIndex }
      },
    );
  }

  getBoud(uuid: string): Promise<UdeuBoud> {
      const path = `smtecno/ssm/deusto/boud/${uuid}`;
      const httpMethod = 'GET';
      const pathParams = {};  // No funciona
      const queryParams = {};
      const headerParams = {};
      const formParams = {};
      const bodyParam = {};
      const contentTypes = [];
      const accepts = [];
      const returnType = '';
      const url = 'alfresco/service';
  
      return this.alfrescoApiService
      .getInstance()
      .contentClient.callApi(
        path,
        httpMethod,
        pathParams,
        queryParams,
        headerParams,
        formParams,
        bodyParam,
        contentTypes,
        accepts,
        returnType,
        url
      );
  }

  getBoudByUuid(boudUUID: string): Promise<NodePaging> {
    const path = 'search';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {
      query: {
        language: "afts",
        query: `${SYS_NODE_UUID_PROP}:'${boudUUID}'`
      },
      include: [
          "properties"
      ]
    };
    const contentTypes = [];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/api/-default-/public/search/versions/1';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  createBoud(udeuCreateBoud: UdeuCreateBoud): Promise<string> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateBoud.data)
    };

    udeuCreateBoud.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = 'smtecno/ssm/deusto/boud';
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  updateBoud(uuid: string, udeuCreateBoud: UdeuCreateBoud): Promise<string> {
    const formParam: any = {
      data: JSON.stringify(udeuCreateBoud.data)
    };

    udeuCreateBoud.files?.forEach((file) => { 
      const fileId = file.id;
      formParam[fileId] = file.file;
    });

    const path = `smtecno/ssm/deusto/boud/${uuid}`;
    const httpMethod = 'PUT';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = formParam;
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  getElements(text: string): Promise<UdeuBoud[]> {
    const path = `/smtecno/ssm/deusto/boud/elements`;
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = { text };
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  generateBoud(UUID: string): Promise<string[]> {
    const path = `/smtecno/ssm/deusto/boud/generate/${UUID}`;
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};
    const bodyParam = {};
    const contentTypes = ['application/json'];
    const accepts = [];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

  publishBoud(UUIDs: string[]): Promise<string> {
    const path = `/smtecno/ssm/deusto/boud/publish`;
    const httpMethod = 'POST';
    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = { UUIDs: JSON.stringify(UUIDs) };
    const bodyParam = {};
    const contentTypes = ['multipart/form-data'];
    const accepts = ['text/plain'];
    const returnType = '';
    const url = 'alfresco/service';

    return this.alfrescoApiService
    .getInstance()
    .contentClient.callApi(
      path,
      httpMethod,
      pathParams,
      queryParams,
      headerParams,
      formParams,
      bodyParam,
      contentTypes,
      accepts,
      returnType,
      url
    );
  }

}
